import type { IDestinationLink } from '../../../../models/destination-link.model';
import { TranslationService } from '../../../../services/translation.service';
import { TransportMode } from '../../../../models/transport-mode.enum';
import { DistanceHelper } from '../../../../helpers/distance.helper';
import { Icon } from '../../Icon';
import { IconMotif } from '../../Icon/icon-motif.enum';

function NonPublicTransportTrip({ destinationLink, className = '' }: { destinationLink: IDestinationLink; className?: string }) {
  return (
    <div className={`d-flex flex-wrap w-100 align-items-center ${className}`}>
      {destinationLink.transportMode === TransportMode.walk && (
        <div className="d-flex align-items-center">
          <Icon motif={IconMotif.Walk} className="me-1" />
          <span>
            {TranslationService.get('common.walk')} {destinationLink.estimatedNumberOfSteps} {TranslationService.get('common.steps')}, {DistanceHelper.format(destinationLink.distanceInMeters)}
          </span>
        </div>
      )}
      {destinationLink.transportMode === TransportMode.bike && (
        <div className="d-flex align-items-center">
          <Icon motif={IconMotif.Bike} className="me-1" />
          <span>
            {TranslationService.get('common.rideabike')} {DistanceHelper.format(destinationLink.distanceInMeters)}
          </span>
        </div>
      )}
    </div>
  );
}

export default NonPublicTransportTrip;
